export const CCRequestType = {
  FILE: 'files',
  SCHEMA: 'schema',
  INGEST: 'urlIngest',
  EXPORT: 'urlExport',
} as const;
export type CCRequestTypeE = typeof CCRequestType[keyof typeof CCRequestType];

export default CCRequestType;
